import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventEmitterService } from '../utils/event-emitter.service';
import { Router } from '@angular/router';
import { ProductCartRequest } from '../../../models/product.model';
import { CartRequest, CartResponse } from '../../../models/cart.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { showNotification } from '../../../consts/utils';
import { superAdminHttpRoutes, superAdminHttpVersion } from '../../../consts/super_admin_http_routes';
import { ApiService } from '../api.services';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private url: string = superAdminHttpVersion.V1;

  constructor(private _httpClient: HttpClient, private _router: Router, private snackBar: MatSnackBar, private apiService: ApiService,
    private _eventEmitterService: EventEmitterService) {
  }

  saveOrUpdateCart(userId: any, companyId: any, productId: string, quantity: number) {
    const cartSTR = localStorage.getItem("cart");
    if (cartSTR) {
      // increment a product
      const cart: CartResponse = JSON.parse(cartSTR);
      const existProduct = cart.products.filter(p => p.productId == productId);
      if (existProduct && existProduct.length) {
        let product = existProduct[0];
        product.quantity += quantity;
        this.updateProduct(cart._id, product.productId, product).subscribe({
          next: (response: any) => {
            localStorage.setItem("cart", JSON.stringify(response.data));
            this._eventEmitterService.emitEvent("refreshCart")
            showNotification(this.snackBar,  response.message, 'success');
          },
          error: (error) => {
            console.error(error);
          },
        });
        return;
      }
      else {
        // add new product
        const productRequest: ProductCartRequest = {
          productId: productId,
          quantity: quantity
        };
        this.addProduct(cart._id, productRequest).subscribe({
          next: (response: any) => {
            localStorage.setItem("cart", JSON.stringify(response.data))
            this._eventEmitterService.emitEvent("refreshCart");
            showNotification(this.snackBar, response.message, 'success');
          },
          error: (error) => {
            console.error(error);
          },
        });
        return;
      }
    }

    // Create new cart
    const cartRequest: CartRequest = {
      userId: userId,
      companyId: companyId,
      products: [{
        productId: productId,
        quantity: quantity
      }]
    }
    this.saveCart(cartRequest).subscribe({
      next: (response: any) => {
        localStorage.setItem("cart", JSON.stringify(response.data))
        this._eventEmitterService.emitEvent("refreshCart");
        showNotification(this.snackBar,  response.message, 'success');
      },
      error: (error) => {
      },
    });
  }

  saveCartAndOrder(userId: any, companyId: any, productId: string, quantity: number) {
    const cartSTR = localStorage.getItem("cart");
    if (cartSTR) {
      // increment a product
      const cart: CartResponse = JSON.parse(cartSTR);
      const existProduct = cart.products.filter(p => p.productId == productId);
      if (existProduct && existProduct.length) {
        let product = existProduct[0];
        product.quantity += quantity;
        this.updateProduct(cart._id, product.productId, product).subscribe({
          next: (response: any) => {
            localStorage.setItem("cart", JSON.stringify(response.data));
            this._eventEmitterService.emitEvent("refreshCart");
            this.saveOrder(response.id).subscribe({
              next: (response) => {
                localStorage.setItem("order", JSON.stringify(response.data));
                this._router.navigate(['/checkout']);
              },
              error: (error) => {
                console.error(error);
              },
            });
          },
          error: (error) => {
            console.error(error);
          },
        });
        return;
      }
      else {
        // add new product
        const productRequest: ProductCartRequest = {
          productId: productId,
          quantity: quantity
        };
        this.addProduct(cart._id, productRequest).subscribe({
          next: (response: any) => {
            localStorage.setItem("cart", JSON.stringify(response.data))
            this._eventEmitterService.emitEvent("refreshCart");
            this.saveOrder(response.id).subscribe({
              next: (response) => {
                localStorage.setItem("order", JSON.stringify(response.data));
                this._router.navigate(['/checkout']);
              },
              error: (error) => {
                console.error(error);
              },
            });
            showNotification(this.snackBar,  response.message, 'success');
          },
          error: (error) => {
            console.error(error);
          },
        });
        return;
      }
    }
    // Create new cart
    const cartRequest: CartRequest = {
      userId: userId,
      companyId: companyId,
      products: [{
        productId: productId,
        quantity: quantity
      }]
    }
    this.saveCart(cartRequest).subscribe({
      next: (response: any) => {
        localStorage.setItem("cart", JSON.stringify(response.data))
        this._eventEmitterService.emitEvent("refreshCart");
        this.saveOrder(response.id).subscribe({
          next: (response) => {
            localStorage.setItem("order", JSON.stringify(response.data));
            this._router.navigate(['/checkout']);
          },
          error: (error) => {
            console.error(error);
          },
        });
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  saveCart(cart: CartRequest) {
    return this.apiService.httpPostCall(`${this.url}${superAdminHttpRoutes.SAVE_CART}`, cart);

  }
  updateUserCart(id: string, userId: string) {
    return this.apiService.httpPatchCall(`${this.url}cart/${id}/users/${userId}`, null);
  }
  updateCompanyCart(id: string, companyId: string) {
    return this._httpClient.patch(`${this.url}/${id}/companies/${companyId}`, null);
  }
  addProduct(cartId: string, product: ProductCartRequest) {
    return this.apiService.httpPostCall(`${this.url}${superAdminHttpRoutes.CART}/${cartId}${superAdminHttpRoutes.PRODUCTS}`, product);
  }
  updateProduct(cartId: string, productId: string, product: ProductCartRequest) {
    return this.apiService.httpPostCall(`${this.url}${superAdminHttpRoutes.CART}/${cartId}${superAdminHttpRoutes.PRODUCTS}/${productId}`, product);
  }
  deleteProduct(cartId: string, productId: string) {
    return this.apiService.httpDeleteCall(`${this.url}${superAdminHttpRoutes.CART}/${cartId}${superAdminHttpRoutes.PRODUCTS}/${productId}`);
  }
  saveOrder(cartId: string): Observable<any> {
    return this.apiService.httpPostCall(`${this.url}order/cart-id/${cartId}`, null);
  }

}
